module.exports = __webpack_public_path__ + "static/media/427ed394-e3ca-49a8-89b1-1dc8ba57e242.a7a20488.JPG";